import { render } from "./StockLedgers.vue?vue&type=template&id=68005d44"
import script from "./StockLedgers.vue?vue&type=script&lang=js"
export * from "./StockLedgers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Accounting/StockLedgers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68005d44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68005d44', __exports__)) {
    api.reload('68005d44', __exports__)
  }
  
  module.hot.accept("./StockLedgers.vue?vue&type=template&id=68005d44", () => {
    api.rerender('68005d44', render)
  })

}


export default __exports__